import { render, staticRenderFns } from "./createGroupModal.vue?vue&type=template&id=63a1d882&scoped=true"
import script from "./createGroupModal.vue?vue&type=script&lang=js"
export * from "./createGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1d882",
  null
  
)

export default component.exports